import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { adminGuard } from './guards/admin.guard';
import { schemasAdminGuard } from './guards/schemas-admin.guard';
import { authRedirectGuard } from './guards/auth-true.guard';
import { LayoutComponent } from './components/layout/layout.component';
import { ModelPlayGroundComponent } from './components/playground/model-play-ground/model-play-ground.component';
import { RenderImagesComponent } from './components/playground/render-images/render-images.component';
import { RulesPlayGroundComponent } from './components/playground/rules-play-ground/rules-play-ground.component';
import { TaskPlayGroundComponent } from './components/playground/task-play-ground/task-play-ground.component';
import { ListComponent } from './components/missions/list/list.component';
import { MissionsComponent } from './components/missions/missions.component';
import { ListComponentRules } from './components/rules/list/list.component';
import { RulesComponent } from './components/rules/rules.component';
import { BoardListComponent } from './components/boards/board-list/board-list.component';
import { BoardsComponent } from './components/boards/boards.component';
import { ListClientsComponent } from './components/clients/list-clients/list-clients.component';
import { ClientsComponent } from './components/clients/clients/clients.component';
import { ListLibraryObjectsComponent } from './components/library-objects/list-library-objects/list-library-objects.component';
import { LibraryObjectsComponent } from './components/library-objects/library-objects.component';
import { SigninComponent } from './components/signin/signin.component';
import { ModelsComponent } from './components/models/models.component';
import { ListModelssComponent } from './components/models/list/list.component';
import { ListUsersComponent } from './users/list/list.component';
import { UsersComponent } from './users/users.component';
import { ListBoardComponent } from './dashboards/list-board/list-board.component';
import { DashboardsComponent } from './dashboards/dashboards.component';
import { MissionsCreateComponent } from './components/missions/missions-create/missions-create.component';
import { PageVisualizerComponent } from './components/recognition-visualizer/page-visualizer/page-visualizer.component';
import { PageVisualizerClientComponent } from './components/recognition-visualizer/page-visualizer-client/page-visualizer-client.component';
import { RecognitionDetailsComponent } from './components/recognition-details/recognition-details.component';
import { CvatTasksComponent } from './components/cvat/cvat-tasks/cvat-tasks.component';
import { AnnotationsComponent } from './components/cvat/annotations/annotations.component';
import { CvatProjectsComponent } from './components/cvat/cvat-projects/cvat-projects.component';
import { AttributeMenuComponent } from './attribute-menu/attribute-menu.component';
import { AttributeListComponent } from './attribute-menu/attribute-list/attribute-list.component';
import { ProjectDetailsCvatComponent } from './components/cvat/cvat-projects/project-details-cvat/project-details-cvat.component';
import { CvatBasicTasksComponent } from './components/cvat/cvat-basic-tasks/cvat-basic-tasks.component';
import { ListCollectorDatasetsComponent } from './components/collector-datasets/list-collector-datasets/list-collector-datasets.component';
import { CollectorDatasetsComponent } from './components/collector-datasets/collector-datasets/collector-datasets.component';
import { SchemasComponent } from './components/schemas/schemas/schemas.component';
import { ListSchemasComponent } from './components/schemas/list-schemas/list-schemas.component';
import { ListAdminSchemasComponent } from './components/schemas/list-admin-schemas/list-admin-schemas.component';
import { ListSchemaRulesComponent } from './components/schema-rules/list-schema-rules/list-schema-rules.component';
import { SchemaRulesComponent } from './components/schema-rules/schema-rules/schema-rules.component';




export const routes: Routes = [

    {
        path: '',
        redirectTo: '/boards',
        pathMatch: 'full'
    },
    {
        path: 'boards',
        component: LayoutComponent,
        children: [
            { path: '', component: BoardListComponent },
            { path: ':id', component: BoardsComponent },
        ],
        canActivate: [authGuard]
    },
    {
        path: 'playground',
        component: LayoutComponent,
        children: [
            { path: '', redirectTo: 'models', pathMatch: 'full' },
            {
                path: 'models',
                children: [
                    { path: '', component: ModelPlayGroundComponent },
                    { path: ':id', component: RenderImagesComponent }
                ]
            },
            { path: 'rules', component: RulesPlayGroundComponent },
        ],
        canActivate: [authGuard]
    },
    {
        path: 'playground',
        children: [
            { path: 'task', component: TaskPlayGroundComponent },
            // { path: 'details/:event_id', component:  PageVisualizerComponent },
            { path: 'details/:id', component: PageVisualizerComponent },
            { path: 'visualizer/:id', component: PageVisualizerClientComponent }
        ],
        // canActivate: [authGuard]
    },
    {
        path: 'auth',
        component: SigninComponent,
        canActivate: [authRedirectGuard]
    },
    {
        path: 'missions',
        component: LayoutComponent,
        children: [
            { path: '', component: ListComponent },
            { path: 'create', component: MissionsCreateComponent },
            { path: ':id', component: MissionsComponent },
        ],
        canActivate: [adminGuard, authGuard],
    },
    {
        path: 'rules',
        component: LayoutComponent,
        children: [
            { path: '', component: ListComponentRules },
            { path: 'create', component: RulesComponent },
            { path: ':id', component: RulesComponent },
        ],
        canActivate: [adminGuard, authGuard],
    },
    {
        path: 'collector-datasets',
        component: LayoutComponent,
        children: [
            { path: '', component: ListCollectorDatasetsComponent },
            { path: 'create', component: CollectorDatasetsComponent},
        ],
        canActivate: [authGuard],
    },
    {
        path: 'schemas',
        component: LayoutComponent,
        children: [
            { path: '', component: ListSchemasComponent},
            { path: 'create', component: SchemasComponent, canActivate: [authGuard, schemasAdminGuard] },
            { path: ':id/edit', component: SchemasComponent, canActivate: [authGuard, schemasAdminGuard] },
        ],
        canActivate: [authGuard],
    },
    {
        path: 'schemas-admin',
        component: LayoutComponent,
        children: [
            { path: '', component: ListAdminSchemasComponent },
        ],
        canActivate: [authGuard, schemasAdminGuard],
    },
    {
        path: 'schema-rules',
        component: LayoutComponent,
        children: [
            { path: '', component: ListSchemaRulesComponent },
            { path: 'create', component: SchemaRulesComponent },
            { path: ':id', component: SchemaRulesComponent },
        ],
        canActivate: [authGuard, schemasAdminGuard],
    },
    {
        path: 'models',
        component: LayoutComponent,
        children: [
            { path: '', component: ListModelssComponent },
            { path: ':id', component: ModelsComponent },
        ],
        canActivate: [adminGuard, authGuard],
    },
    {
        path: 'clients',
        component: LayoutComponent,
        children: [
            { path: '', component: ListClientsComponent },
            { path: 'create', component: ClientsComponent },
            { path: ':id', component: ClientsComponent },
        ],
        canActivate: [adminGuard, authGuard],
    },
    {
        path: 'library-objects',
        component: LayoutComponent,
        children: [
            { path: '', component: ListLibraryObjectsComponent },
            { path: 'create', component: LibraryObjectsComponent },
            { path: ':id', component: LibraryObjectsComponent },
        ],
        canActivate: [adminGuard, authGuard],
    },
    {
        path: 'library-attributes',
        component: LayoutComponent,
        children: [{
            path: '',
            component: AttributeMenuComponent,
            children: [
                {
                    path: 'list/:type',
                    component: AttributeListComponent,
                    outlet: 'table'
                }
            ]
        }
        ]
    },
    {
        path: 'users',
        component: LayoutComponent,
        children: [
            { path: '', component: ListUsersComponent },
            { path: 'create', component: UsersComponent },
            { path: ':uid', component: UsersComponent },
        ],
        canActivate: [adminGuard, authGuard],
    },
    {
        path: 'cvat',
        component: LayoutComponent,
        canActivate: [adminGuard, authGuard],
        children: [
            { path: 'projects', component: CvatProjectsComponent },
            {
                path: 'projects/:project_id', component: ProjectDetailsCvatComponent,
                children: [
                    { path: 'tasks', component: CvatTasksComponent },
                ]
            },
            {
                path: 'projects/:project_id/tasks/annotations',
                children: [
                    { path: '', component: AnnotationsComponent },
                    { path: ':task_id', component: AnnotationsComponent },
                ]
            },
            {
                path: 'projects/:project_id/basic-tasks',
                children: [
                    { path: '', component: CvatBasicTasksComponent },
                    { path: ':task_id', component: CvatBasicTasksComponent },
                ]
            }

        ]
    },
    {
        path: 'dashboards',
        component: LayoutComponent,
        children: [
            { path: '', component: ListBoardComponent },
            { path: 'create', component: DashboardsComponent },
            { path: ':uid', component: DashboardsComponent },
        ],
        canActivate: [adminGuard, authGuard],
    }
];

